module.exports = __webpack_public_path__ + "img/Excavator.b34b33be.jpg";